import ReactDOM from "react-dom";

import App from "./App";
import "./index.css";
import "leaflet/dist/leaflet.css";

ReactDOM.render(<App />, document.querySelector("#root"));
